import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import DropdownMenuItems from '../../../components/navigation/account/DropdownMenuItems';
import { IconAccountCircle } from '../../sharedComponents/icons/Icons';
import { showLoginModal } from '../../../actions/navigation/loginActions';
import Button from '../../../components/sharedComponents/Button';

export default function SignInOrAccountPanel({
    logout,
    profilePicture,
}) {
    const dispatch = useDispatch();

    // Redux state
    const account = useSelector((state) => state.auth.account?.account);

    // If the user is logged in
    if (account) {
        const firstName = account.first_name;
        let fullName = firstName;

        if (account.last_name.length > 0) {
            fullName = `${firstName} ${account.last_name[0]}.`;
        }

        return (
            <div className="nav-mobile-menu-account-panel">
                <div className="nav-mobile-user-profile-head">
                    <div className="nav-profile-info">
                        {profilePicture}
                        <span className="ml-1">
                            {fullName}
                        </span>
                    </div>

                    <Button
                        appearance="link"
                        className="rec-close-dropdown-button"
                        onClick={logout}
                        aria-label="Sign Out"
                        type="button">
                        Sign Out
                    </Button>

                </div>

                <DropdownMenuItems
                    commercialAccount={account.is_commercial_account}
                    signOut={logout}
                    hideBottomSignOut
                />
            </div>
        );
    }

    // If the user is logged out
    return (
        <button
            className="nav-mobile-menu-row"
            aria-label="Sign Up / Log In"
            type="button"
            onClick={() => {
                dispatch(showLoginModal());
            }}
        >
            Sign Up / Log In
            <span className="nav-mobile-menu-row-icon">
                <IconAccountCircle />
            </span>
        </button>
    );
}

SignInOrAccountPanel.propTypes = {
    logout: PropTypes.func,
    profilePicture: PropTypes.node,
};
